import ChatCTA from '@/strapi/components/FeatureCTA/ChatCTA';
import RepairCTA from '@/strapi/components/FeatureCTA/RepairCTA';
import ReplaceCTA from '@/strapi/components/FeatureCTA/ReplaceCTA';

export const InlineComponents = [
	{ id: 'ReplaceCTA', component: <ReplaceCTA showImage={true} /> },
	{ id: 'RepairCTA', component: <RepairCTA showImage={true} /> },
	{ id: 'ChatCTA', component: <ChatCTA showImage={true} /> },
];
